import { Layout } from '../components/Layout.jsx';
import { HomePage } from '../pages/HomePage.jsx';

export function AppRoutes() {
  return (
    <Layout>
      <HomePage />
    </Layout>
  );
}
